import React, { useState, useRef, useEffect } from 'react';

import Video from './components/Video';
import { VideoContext } from './context/VideoContext';
import RotatePhone from './components/RotatePhone';

function App() {

  useEffect(() => {
    document.body.addEventListener("focusin", () => {
      console.log(document.activeElement);
    });
  }, []);
  
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [overlays, setOverlays] = useState({ visible: true });
  const [currentTime, setCurrentTime] = useState(0);
  const [currentProgress, setCurrentProgress] = useState(0);
  const [currentOverlay, setCurrentOverlay] = useState(null);
  const [currentDeepDive, setCurrentDeepDive] = useState(null);
  const [currentDeepDiveIndex, setCurrentDeepDiveIndex] = useState(null);
  const [playAudio, setPlayAudio] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [openMenu, setOpenMenu] = useState(false);
  const [lastEvent, setLastEvent] = useState(null);
  const deepDiveButtonRefs = useRef([]);

  return (
    <VideoContext.Provider value={{ 
      position, setPosition, 
      overlays, setOverlays, 
      currentTime, setCurrentTime, 
      currentOverlay, setCurrentOverlay, 
      currentDeepDive, setCurrentDeepDive,
      currentDeepDiveIndex, setCurrentDeepDiveIndex,
      playAudio, setPlayAudio,
      isLoading, setIsLoading,
      currentProgress, setCurrentProgress,
      openMenu, setOpenMenu,
      lastEvent, setLastEvent,
      deepDiveButtonRefs,
    }}>

      <Video />
      <RotatePhone />
      
    </VideoContext.Provider>
  );
}

export default App;
